import { ChangeEvent, FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Tab, Tabs } from '@material-ui/core';
import { useStylesSecond } from './styles';
import TabPanel from 'components/TabPanel';
import { GithubInfoTable } from './GithubSyncInfoTable';
import { GithubSyncUser } from './GithubSyncUserTable';
import { useLocation } from 'react-router-dom';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
export const GithubTable: FC = observer(() => {
  const classes = useStylesSecond();
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }
  const query = useQuery();
  const queryValue = query.get('value');
  const defaultTabs = (Array.isArray(queryValue) ? queryValue[0] : queryValue) ?? 'one';
  const [value, setValue] = useState<string>(defaultTabs);

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <Tabs
          value={value}
          className={classes.tabs}
          TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
          onChange={handleChange}
        >
          <Tab value='one' wrapped label={<span>INFO</span>} {...a11yProps('one')} className={classes.label} />
          <Tab value='two' wrapped label={<span>Users</span>} {...a11yProps('two')} className={classes.label} />
        </Tabs>
        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <GithubInfoTable />
          </TabPanel>
          <TabPanel value={value} index='two'>
            <GithubSyncUser />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
});
